(function($) {

$('.site-menu-toggle').click(function(){
    var $this = $(this);
    if ( $('body').hasClass('menu-open') ) {
      $this.removeClass('open');
      $('.js-site-navbar').fadeOut(400);
      $('body').removeClass('menu-open');
    } else {
      $this.addClass('open');
      $('.js-site-navbar').fadeIn(400);
      $('body').addClass('menu-open');
    }
  });

var owl = $('#banner-item');
     owl.owlCarousel({
     items:1,
     loop: true,
     autoplay: true,
     smartSpeed: 2000,
    autoplayTimeout: 8000, // Set delay to 8 seconds
     nav: false,
     dots:true,
       margin:20
  });

 /*---------------------------------
        Product Details Pic Slider
    ----------------------------------*/

 $(".product__details__pic__slider").owlCarousel({
        loop: true,
        margin: 10,
        items: 7,
        dots: true,
        smartSpeed: 1200,
        autoHeight: false,
        autoplay: true
    });

  /*------------------
    Single Product
  --------------------*/
    $('.product__details__pic__slider img').on('click', function () {

        var imgurl = $(this).data('imgbigurl');
        var bigImg = $('.product__details__pic__item--large').attr('src');
        if (imgurl != bigImg) {
            $('.product__details__pic__item--large').attr({
                src: imgurl
            });
        }
    });


  /*-------------------
    Radio Btn
  --------------------- */
    $(".product__details__option__size label").on('click', function () {
        $(".product__details__option__size label").removeClass('active');
        $(this).addClass('active');
    });

})(jQuery);
